import { Settings } from '@email-editor/ui'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { emailActions, emailSelectors, managementActions, useEmail } from '../../../../store'
import { SettingsTitle } from './components/common/SettingsTitle'
import ColorPicker from './options/ColorPicker'
import FontSize from './options/FontSize'
import MaxWidth from './options/MaxWidth'

export default function GlobalSettings() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const settings = useEmail(emailSelectors.getSettings)

  function updateSetting<K extends keyof Settings>(setting: K) {
    return function (value: Settings[K]) {
      dispatch(
        emailActions.updateGlobalSettings({
          ...settings,
          [setting]: value,
        }),
      )
    }
  }

  function toggleSettings() {
    dispatch(managementActions.toggleGlobalSettingsEditing())
  }

  return (
    <>
      <SettingsTitle onBack={toggleSettings}>{t('global_settings.title')}</SettingsTitle>
      <div className="customScroll overflow-y-auto">
        <FontSize update={updateSetting('textFontSize')} value={settings.textFontSize} />
        <ColorPicker
          label="global_settings.background_color.label"
          color={settings.backgroundColor}
          update={updateSetting('backgroundColor')}
        />
        <ColorPicker
          label="global_settings.content_background_color.label"
          color={settings.contentBackgroundColor}
          update={updateSetting('contentBackgroundColor')}
        />
        <ColorPicker
          label="global_settings.link_color.label"
          color={settings.linkColor}
          update={updateSetting('linkColor')}
        />
        <MaxWidth
          label="global_settings.max_width.label"
          maxWidth={settings.maxWidth}
          update={updateSetting('maxWidth')}
        />
      </div>
    </>
  )
}
